import { ListDataProps } from '../../components/list/data';

export const sampleList: ListDataProps[] = [
  {
    iidx: 1,
    iidx2: 1,
    courtcode: '',
    unitno: '',
    type: 'a',
    address: '서울특별시 구로구 개봉동 310-19, 더에코그로브 6층 601호',
    caseno: '2025타경10833',
    courtname: '서울남부지법',
    category: '다세대(빌라)',
    viewgray: '',
    l_area: 1,
    l_pyeong: 1,
    b_area: 1,
    b_pyeong: 1,
    viewgray2: '',
    a_price: '',
    minprice: '108000000',
    bidprice: '108000000',
    status: '',
    saledate: '',
    count: '',
    bid: '신건',
    bidno: 1,
    isblockdeal: '',
    img: 'https://aws-npl-images.s3.ap-northeast-2.amazonaws.com/B000212_2025타경9210/gallery/3afbe4bc572643b8a756368e004186a2_0.jpg',
    Img: [],
    minPrice: 86400000,
    isBid: false,
    b_item_info: [],
    a_per: 108000000,
    is_like: false,
    level: 1,
    group: '',
    memo: null,
  },
  {
    iidx: 2,
    iidx2: 2,
    courtcode: '',
    unitno: '',
    type: 'a',
    address: '서울특별시 구로구 개봉동 310-19, 더에코그로브 6층 601호',
    caseno: '2025타경10833',
    courtname: '서울남부지법',
    category: '다세대(빌라)',
    viewgray: '',
    l_area: 1,
    l_pyeong: 1,
    b_area: 1,
    b_pyeong: 1,
    viewgray2: '',
    a_price: '',
    minprice: '108000000',
    bidprice: '108000000',
    status: '',
    saledate: '',
    count: '',
    bid: '신건',
    bidno: 1,
    isblockdeal: '',
    img: 'https://aws-npl-images.s3.ap-northeast-2.amazonaws.com/B000210_2025타경102553/gallery/1d18e6b814c44192bbeed9d3ea7f2ef9_0.jpg',
    Img: [],
    minPrice: 86400000,
    isBid: false,
    b_item_info: [],
    a_per: 108000000,
    is_like: false,
    level: 1,
    group: '',
    memo: null,
  },
  {
    iidx: 3,
    iidx2: 1,
    courtcode: '',
    unitno: '',
    type: 'a',
    address: '서울특별시 구로구 개봉동 310-19, 더에코그로브 6층 601호',
    caseno: '2025타경10833',
    courtname: '서울남부지법',
    category: '다세대(빌라)',
    viewgray: '',
    l_area: 1,
    l_pyeong: 1,
    b_area: 1,
    b_pyeong: 1,
    viewgray2: '',
    a_price: '',
    minprice: '108000000',
    bidprice: '108000000',
    status: '',
    saledate: '',
    count: '',
    bid: '신건',
    bidno: 1,
    isblockdeal: '',
    img: 'https://aws-npl-images.s3.ap-northeast-2.amazonaws.com/B000210_2025타경102322(1)/gallery/c04bd340288344b888b6eb312ee0d498_0.jpg',
    Img: [],
    minPrice: 86400000,
    isBid: false,
    b_item_info: [],
    a_per: 108000000,
    is_like: false,
    level: 1,
    group: '',
    memo: null,
  },
  {
    iidx: 4,
    iidx2: 1,
    courtcode: '',
    unitno: '',
    type: 'a',
    address: '서울특별시 구로구 개봉동 310-19, 더에코그로브 6층 601호',
    caseno: '2025타경10833',
    courtname: '서울남부지법',
    category: '다세대(빌라)',
    viewgray: '',
    l_area: 1,
    l_pyeong: 1,
    b_area: 1,
    b_pyeong: 1,
    viewgray2: '',
    a_price: '',
    minprice: '108000000',
    bidprice: '108000000',
    status: '',
    saledate: '',
    count: '',
    bid: '신건',
    bidno: 1,
    isblockdeal: '',
    img: 'https://aws-npl-images.s3.ap-northeast-2.amazonaws.com/B000212_2025타경8865/gallery/caeb317606a24182a069771336448c83_0.jpg',
    Img: [],
    minPrice: 86400000,
    isBid: false,
    b_item_info: [],
    a_per: 108000000,
    is_like: false,
    level: 1,
    group: '',
    memo: null,
  },
  {
    iidx: 5,
    iidx2: 1,
    courtcode: '',
    unitno: '',
    type: 'a',
    address: '서울특별시 구로구 개봉동 310-19, 더에코그로브 6층 601호',
    caseno: '2025타경10833',
    courtname: '서울남부지법',
    category: '다세대(빌라)',
    viewgray: '',
    l_area: 1,
    l_pyeong: 1,
    b_area: 1,
    b_pyeong: 1,
    viewgray2: '',
    a_price: '',
    minprice: '108000000',
    bidprice: '108000000',
    status: '',
    saledate: '',
    count: '',
    bid: '신건',
    bidno: 1,
    isblockdeal: '',
    img: 'https://aws-npl-images.s3.ap-northeast-2.amazonaws.com/B000210_2024타경126377/gallery/137910e1eb5540aeadce9935a851338f_0.jpg',
    Img: [],
    minPrice: 86400000,
    isBid: false,
    b_item_info: [],
    a_per: 108000000,
    is_like: false,
    level: 1,
    group: '',
    memo: null,
  },
];
